export interface SnackbarProps {
  show: boolean;
  errorMessage: string;
}

export const defaultSnackbarProps: SnackbarProps = {
  errorMessage: "",
  show: false,
};

export const acceptedFileExtensions = ["pdf", "jpeg", "png", "jpg"];
